export enum ProgramType {
  ACTIVE = 'ACTIVE',
  POLICY = 'POLICY',
  FINISHED = 'FINISHED',
}
